import { Loader } from '@googlemaps/js-api-loader'
import { useEffect, useState } from 'react'
import storeConfig from '../../../store.config'

export const useGoogleMapsAPI = () => {
  const [google, setGoogle] = useState<any>(null)
  const [places, setPlaces] = useState<any>(null)
  const [marker, setMarker] = useState<any>(null)

  const loader = new Loader({
    apiKey: `${storeConfig.api.googleApiKey}`,
    version: 'weekly',
    region: 'IT',
    language: 'it',
  })

  const loadPlaces = async () => {
    loader
      .importLibrary('places')
      .then((places: any) => {
        setPlaces(places)
      })
      .catch((error) => {
        console.error('Error loading Places: ', error)
      })
  }

  const loadMarker = async () => {
    loader
      .importLibrary('marker')
      .then((marker: any) => {
        setMarker(marker)
      })
      .catch((error) => {
        console.error('Error loading Marker: ', error)
      })
  }

  const loadGoogleMaps = async () => {
    loader
      .importLibrary('maps')
      .then((google: any) => {
        setGoogle(google)
      })
      .catch((error) => {
        console.error('Error loading Google Maps: ', error)
      })
  }

  useEffect(() => {
    loadGoogleMaps()
    loadPlaces()
    loadMarker()
  }, [])

  return {
    places,
    google,
    marker,
  }
}
